@if (visible) {
  <i
    class="fas fa-forward pointer"
    [ngClass]="{'hidden': clicked}"
    matTooltip="{{ 'skipEye' | translate | titlecase }}"
    (click)="onClick()">
  </i>
}
@if (clicked) {
  <app-load [isLight]="true" style="font-size: 3px;">
  </app-load>
}
